// 中文简体语言包
export default {
  // index 首页
  confirm: '确定',
  cancel: '取消',
  noData: '暂无相关数据',
  endTips: '没有更多了，看看别的吧',
  copySuccess: '复制成功',
  failed: '复制失败',
  index: {
    searchTips: '搜索您想购买的商品或者店铺',
    newProduct: '新品推荐',
    specialDiscounts: '限时折扣',
    groupDiscount: '优惠团购',
    spikeSpecial: '秒杀专场',
    couponCentre: '领券中心',
    memberCentre: '会员中心',
    distributionCentre: '分销中心',
    pointsMall: '积分商城',
    spikeZone: '秒杀专区',
    day: '天',
    seckillTips: '秒杀活动正在进行中',
    more: '更多',
    dailyRecommendation: '每日推荐',
    recommendationTips: '各种新鲜好物',
    prodNotFoundTips: '没有找到对应商品，看看别的吧',
    noMoreTips: '没有更多了，看看别的吧',
    cancel: '取消',
    confirm: '确认'
  },
  // user-setting 用户设置页面
  userSettings: {

  },
  // payment 支付页面
  payment: {
    theRemainingTime: '剩余时间',
    determinePayment: '确定付款',
    PayWithAli: '支付宝支付',
    payWithWeChat: '微信支付',
    balancePay: '余额支付',
    cardPay: '园区卡支付',
    tips: '提示',
    confirmBalancePay: '是否确认使用余额支付？点击确认按钮后将从余额支付本单金额',
    cancel: '取消',
    confirm: '确认',
    cancelBalancePay: '已取消使用余额支付',
    shortBalance: '余额不足，请先充值！当前账户余额：'
  },
  // my 我的页面
  my: {
    changeLang: 'In English'
  },

  // 分销员页面
  distribution: {
    // applyDist.vue
    applyDistributor: '申请成为分销员',

    // applyDistCon.vue
    mobilePhone: '手机号',
    actualName: '真实姓名',
    identification: '身份证号码',
    identificationTips: '请输入正确的身份证号码',
    uploadIDFront: '请上传身份证人像面',
    uploadIDBack: '请上传身份证国徽面',
    uploadIDHand: '请上传手持身份证照片',
    enterRealName: '请输入真实姓名',
    applicationSubmitted: '申请已提交，请等待审核',
    enterMobileNumber: '请输入手机号码',
    enterMobileNumberTips: '手机号输入错误',
    submitApplication: '提交申请',
    applicationReview: '您提交的申请正在审核中',
    applicationFailed: '您的申请未通过，具体原因请咨询客服，重新进行申请',
    distributorBanned: '您的分销员身份已被封禁，具体原因请咨询客服',
    distributionPromotionHasBeenClosed: '分销推广已关闭',
    distributorCleared: '您的分销身份已被封禁，请联系管理员',
    cancel: '取消',
    confirm: '确认',
    // dis-center.vue
    noAnnouncement: '暂无公告',
    vip: '会员',
    myBalance: '可提现余额（元）',
    totalIncome: '总收益（元）',
    withdrawalsNow: '立即提现',
    promoteGoods: '推广商品',
    distributionWinWin: '分销共赢',
    inviteFriends: '邀请好友',
    promoteRewards: '推广奖励',
    myUser: '我的用户',
    myPromotion: '我的推广',
    distributorList: '分销员列表',
    incomeBreakdown: '收益明细',
    withdrawalsRecord: '提现记录',

    // withdrawal.vue
    withdrawalAmount: '提现金额',
    availableCashAmount: '可提现金额￥',
    withdrawAll: '全部提现',
    confirmWithdrawal: '确认提现',
    enterCorrectAmount: '请输入正确金额！',
    insufficientBalance: '余额不足',
    lessThanWithdrawalAmount: '提现金额小于最小提现金额',
    withdrawalApplicationSubmitted: '提现申请已提交',

    // draw-rule.vue
    WithdrawalRules: '提现规则',
    WithdrawalRules1: '1、单次提现额度不得低于',
    yuan: '元',
    WithdrawalRules2: '且不得高于',
    WithdrawalRules3: '2、每个用户每天提现次数无限制',
    WithdrawalRules31: '2、每个用户每',
    WithdrawalRules32: '天有',
    WithdrawalRules34: '月有',
    WithdrawalRules33: '次提现的机会',
    WithdrawalRules4: '最终解释权归平台所有。',

    // take-notes.vue
    noRecords: '暂无记录',
    totalWithdrawa: '总提现',
    wechatPayment: '微信支付',
    offlinePayment: '线下打款',
    theFallback: '回退',
    rejection: '拒绝提现',
    withdrawing: '待审核',
    hasArrived: '已到账',
    loading: '正在加载...',
    noMore: '没有更多了~',
    noPromotionProduct: '没有找到推广商品哦~',
    noRecordsFound: '没有找到相关记录',
    noWithdrawalRecord: '还没有提现记录哦~',
    unpaid: '待支付',
    applicationApproved: '申请成功',
    successfulWithdrawal: '提现成功',
    withdrawalFailed: '提现失败',

    // income-details.vue
    cumulativeIncome: '累计收益(元)',
    availableBalance: '可提余额(元)',
    toBeSettled: '待结算(元)',
    monthEarnings: '本月收益',
    todayEarnings: '今日收益',
    reward: '奖励',
    other: '其他',
    reward1: '直推奖励',
    reward2: '间推奖励',
    reward3: '邀请奖励',
    reward4: '平台修改',
    noProfitToday: '今天还没有收益哦~',
    totalPeople: '共邀请人数',

    // promotion-order.vue
    unsettlement: '未结算',
    settled: '已结算',
    incomeExpired: '已失效',
    // 订单失效原因
    reasonsForInvalidOrders1: '订单失效，失效原因：分销佣金大于或等于商家收益',
    reasonsForInvalidOrders2: '订单失效，失效原因：订单项售后成功',
    reasonsForInvalidOrders3: '订单失效，失效原因：分销佣金小于0.01',

    // promotionProd.vue
    enterProductName: '请输入商品名称',
    newest: '最新',
    sales: '销量',
    price: '价格',
    weChat: '微信',
    QRCode: '二维码',
    expectedEarn: '预计可赚',
    saveAlbum: '保存至相册',
    cpb: 'bWFsbDRq',
    shareIt: '分享',
    downloadComplete: '已保存至相册',
    failedSave: '保存失败，请再次点击保存到相册',
    failedSaveTips: '保存失败，请授权相关访问权限',
    shareFriendsNow: '立即分享给好友',
    shareFriendsTips1: '朋友通过你分享的页面成功购买后，你可获得对应的佣金，佣金可“个人中心-分销员中心" 里查看',
    shareFriendsTips2: '点击屏幕右上角将本商品分享给好友',

    // my-users.vue and my-friends.vue
    people: '人',
    avatar: '用户头像',
    nickname: '用户昵称',
    bindingDate: '绑定日期',
    noUsersYet: '还没有用户哦~',
    notDistributionUsers: '您还没有分销用户~',
    notDistributionFriends: '您还没有分销好友~',
    nicknameEmptyTips: '用户名不能为空',
    userInformation: '用户信息',
    cumulativeIncomeRMB: '累计收益 (元)',
    joinTime: '加入时间：',
    totalInviteFriends: '共邀请好友',
    accumulatedOrders: '累计成交订单：',
    totalPromotionUsers: '共推广用户',
    distributionErrorTxt: '当前功能未开启',
    passAudit: '恭喜审核通过！'
  },

  // chat 客服页面
  chat: {
    sendLink: '发送链接',
    productLinks: '商品链接',
    clickToLoadMore: '点击加载更多',
    send: '发送',
    imgs: '图片',
    inquiring: '正在查询',
    myOrders: '我的订单',
    recentlyViewed: '最近浏览',
    orderNumber: '订单号',
    PCS: '平台客服',
    MCS: '商家客服',
    none: '无',
    loading: '加载中',
    allLoaded: '已全部加载完毕',
    noMore: '没有更多了',
    read: '已读',
    unRead: '未读',
    noRecord: '暂无记录',
    customerOffline: '当前客服不在线',
    loginOtherSide: '用户在别处登录,请刷新页面',
    reLogin: '无法获取用户信息,请重新登录',
    sendOrderNumber: '发送订单号',
    pleaseLoginAgain: '账号已下线，请重新登录',
    paymentAmount: '支付金额',
    onlineCustomerService: '在线客服',
    onLine: '在线',
    offLine: '离线',
    cannotSendBlankMessage: '不能发送空白消息哦'
  },

  // liveBroadcast.vue
  tabbarLive: '直播',
  liveBroadcast: '直播',
  inputBlogger: '输入主播/直播间/商品...',
  liveing: '直播中',
  notStarted: '未开始',
  finished: '已结束',
  noBroadcasting: '禁播',
  suspend: '暂停',
  abnormal: '异常',
  liveBroadcastTips: '暂无相关直播数据',
  pleaseOpenInWechat: '请在微信小程序打开',
  inLive: '直播中',
  more: '更多',
  commodity: '商品',
  pickitUp: '自提',
  successfullyAddedCart: '加入购物车成功',

  // user-login 用户登录
  userLogin: {
    userLogin: '用户登录',
    username: '账号',
    userName: '用户名',
    userNameCannotChange: '用户名无法更改',
    enterUsername: '请输入手机号',
    usernameWarn: '请输入账号',
    password: '密码',
    enterPassword: '请输入密码',
    changePassword: '修改密码',
    nextStep: '下一步',
    passwordVerification: '密码由字母、数字和特殊符号三种字符组成8-20位半角字符，区分大小写',
    enterNewPasswordTips: '请输入正确的密码格式',
    notUsername: '还没有账号？',
    registeredUsername: '去注册',
    phoneNumber: '手机号',
    enterPhone: '请输入登录手机号',
    phoneWarn: '手机号格式错误',
    verificationCode: '验证码',
    enterCodeFirst: '请先获取验证码',
    getCode: '获取验证码',
    enterCode: '请输入验证码',
    newPassword: '新密码',
    enterNew: '请输入新密码',
    confirmNew: '确认密码',
    enterNewAgain: '请再次输入新密码',
    comparedPassword: '确认密码与新密码不一致',
    login: '登录',
    loginSuccessful: '登录成功!',
    backHomepage: '回到首页',
    confirmChanges: '确认修改',
    BackLogin: '返回登录',
    backToPrev: '返回上一页',
    pwdCantBeEmpty: '密码不能为空',
    consentOfLoginRepresentative: '登录代表同意',
    consentOfRegisteredRepresentative: '注册代表同意',
    termsOfService: '服务条款',
    privacyPolicy: '隐私策略',
    and: '和',
    forgetPwd: '忘记密码',
    loginAgree: '已阅读并同意',
    hadBind: '该手机号对应的账户已绑定其他微信号',
    regAgree: '若手机号未注册将进入注册流程，已阅读并同意',
    phoneFastLogin: '手机号极速登录',
    otherLogMethods: '其他登录方式',
    phoneLogin: '手机验证',
    accountLogin: '账号登录',
    agreementTips: '请先阅读并勾选协议',
    bindedTipsTit: '该账户已绑定其他微信',
    bindedTipsCon: '一个账户只能绑定一个微信，您的手机号已经绑定了其他微信，请您先解除后再尝试。',
    bindedTipsBtn: '知道了',
    codeErrorTips: '登录信息异常，请重新登录',
    tips: '提示',
    confirm: '确定'
  },

  // cancellation 注销
  cancellation: {
    cancellationNotice: '注销须知',
    cancellationCon: '如果您申请注销商城帐号，请在提交申请前确认以下信息，以保证您的帐号和财产安全：',
    cancellationTips1: '您的帐号处于正常使用状态，未发生过被盗、被封禁（禁言、停用）、其他帐号异常情形等；',
    cancellationTips2: '帐号内财产已结清。 包括：您的钱包内余额已清空或已全部提现，您的账户内没有未完成的权益和订单。您也可选择放弃该帐号内的财产。',
    cancellationTips3: '帐号已解除与第三方产品的绑定关系或授权登录关系。',
    cancellationTips4: '帐号未涉及任何争议纠纷。',
    cancellationConfirmTips: '确认注销账号吗？',
    cancellationConfirm: '注销账号',
    cancellationCancel: '退出注销',
    accountCancellation: '注销账号',
    compulsoryCancellation: '强制注销'
  },

  // logout 退出登录
  logout: {
    logged: '当前登录',
    logoutNotice: '退出登录后，将有以下影响：',
    logoutNotice1: '您的账户与微信解绑',
    logoutNotice2: '将无法使用该账户的资产下单',
    logoutNotice3: '查询不到该账户订单物流信息',
    logoutNotice4: '无法领取优惠券、红包等',
    logoutConfirm: '确认退出登录吗？',
    logoutBtn: '退出登录',
    keepLogin: '保持登录'
  }
}
